export class Messages {
    public static readonly NoResultsFound = 'You have no data to show yet.';
    public static readonly FileUploadFailed =
        'There was an error uploading your file. Please try again.';
    public static readonly NavigationForbidden = 'You do not have permission to view that page.';
    public static fileTypeNotSupported(mimeType: string): string {
        return `Sorry, the file type "${mimeType}" is not supported.`;
    }
    public static fileTypeNotRecognized(filename: string): string {
        return `Sorry, the file format of "${filename}" could not be determined.`;
    }
    public static spreadsheetFileTypeNotRecognized(filename: string): string {
        return `Sorry, the file format of "${filename}" could not be determined. Try converting it to .csv or .xlsx format and trying again.`;
    }
}
